import {ExportProfessionalCaregiversReportData} from './export-professional-caregivers-get-report-data';

export function exportProfessionalProcessReportData({
  reportData,
}: {
  reportData: ExportProfessionalCaregiversReportData;
}): ExportProfessionalCaregiversReportData['users'] {
  const getOccupationName = (occupationId: string) => {
    return reportData.occupations[occupationId]?.designation ?? occupationId;
  };

  const getRoleNames = (rolesIds: string[]) => {
    return rolesIds.map((roleId) => reportData.roles[roleId]?.name ?? roleId);
  };

  return reportData.users
    .map((userInfo) => {
      const userDetails = userInfo.userId;

      return {
        ...userInfo,
        userId: {
          ...userDetails,
          occupationId: getOccupationName(userDetails.occupationId),
        },
        rolesIds: getRoleNames(userInfo.rolesIds ?? []),
      };
    })
    .sort(sortByName);
}

function sortByName(entryA: any, entryB: any) {
  return getUserName(entryA.userId).localeCompare(getUserName(entryB.userId), undefined, {
    sensitivity: 'base',
  });
}

function getUserName(user?: any) {
  return user?.displayName ?? user?.name ?? '';
}
